import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Guide to open source development in the cloud`}</h1>
    <p>{`Enterprises are increasingly using more than one cloud in their IT solutions, a trend that is thanks, in large part, to the fact that most major clouds are built using open source software. An `}<a parentName="p" {...{
        "href": "https://developer.ibm.com/blogs/oreilly-open-source-skill-survey-blog/"
      }}>{`O’Reilly survey`}</a>{`, commissioned by IBM in Fall 2020, pointed out that, when choosing cloud providers, 70% of respondents prefer one based on open source. The survey went on to say:`}</p>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Developers who want to develop cloud applications should work on honing their open source skills, which underly every major cloud platform, instead of only focusing on building skills for a proprietary cloud`}</em>{`.`}</p>
    </blockquote>
    <p>{`The most desirable open source skills are those related to Linux (containers), artificial intelligence and machine learning, and data storage.`}</p>
    <p>{`As both the cloud and open source landscapes evolve, we saw a need for a guide to highlight important aspects of hybrid cloud and multiclodu development—and their corresponding open source services.`}</p>
    <p>{`This goals of this guide are to provide:`}</p>
    <ol>
      <li parentName="ol">{`Comprehensive learning for hybrid cloud and multicloud developers.`}</li>
      <li parentName="ol">{`A cloud-neutral view of how various clouds are using open source in their offerings.`}</li>
    </ol>
    <p>{`In each section of the guide you will find:`}</p>
    <ul>
      <li parentName="ul">{`An introduction to the basic concepts related to cloud use cases.`}</li>
      <li parentName="ul">{`Key open source projects that solve problems related to that area.`}</li>
      <li parentName="ul">{`Information about how certain clouds take advantage of open source solutions related to those use cases.`}</li>
      <li parentName="ul">{`Additional learning resources so you can further your understanding.`}</li>
    </ul>
    <h2>{`What’s leading to multicloud and hybrid cloud adoption?`}</h2>
    <p>{`In short, the answer is: Choice. Businesses want the ability to choose the best platform and services that will give them a competitive advantage. Other factors contributing to the rise of mulitcloud and hybrid cloud development include:`}</p>
    <ul>
      <li parentName="ul">{`Each cloud has inherent strengths and weaknesses. Using a mulitcloud approach to development allows you to take advantage of the strengths of multiple clouds.`}</li>
      <li parentName="ul">{`Spreading workloads across clouds reduces risk.`}</li>
      <li parentName="ul">{`Using different clouds may reduce costs in the long term.`}</li>
    </ul>
    <p>{`Developers benefit from multicloud development because it offers them the ability to:`}</p>
    <ul>
      <li parentName="ul">{`Make an impact immediately using the cloud skills they have, while growing their skills in other clouds`}</li>
      <li parentName="ul">{`Implement specific use cases for their work`}</li>
      <li parentName="ul">{`Choose the cloud environment or services that work best for the problem they’re solving`}</li>
      <li parentName="ul">{`Choose cloud services that will grow with their needs`}</li>
    </ul>
    <h2>{`Use cases for cloud development`}</h2>
    <p>{`This guide walks you through common use cases that you will encounter as a cloud developer, including:`}</p>
    <ul>
      <li parentName="ul">{`Extending cloud services with AI`}</li>
      <li parentName="ul">{`Exposing a service API`}</li>
      <li parentName="ul">{`Building and using containers`}</li>
      <li parentName="ul">{`Planning, preparing, and using Databases`}</li>
      <li parentName="ul">{`Coordinating your team’s development, testing, and DevOps practices`}</li>
    </ul>
    <p>{`We’d love for contributors to add additional use cases as well.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      